import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import weui from "weui.js";
import {
  Button,
  Cell,
  CellBody,
  CellButton,
  CellHeader,
  Cells,
  CellsGroup,
  CellsTitle,
  Input,
  Preview,
  PreviewBody,
  PreviewButton,
  PreviewFoot,
  PreviewHead,
  PreviewItem
} from "../../components/weui";
import { withWechatScanCode } from "../../hooks/withWechatScanCode";
import { commonService, userService } from "../../services";
import { clearMeters, refreshMeters } from "../../stores";
import { urls } from "../../urls";
import { getAxiosError } from "../../utils";
import "./index.css";

const MeterBindingInner = (props) => {
  const { scanCode, scanCodeEnabled } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [meterNo, setMeterNo] = useState("");
  const [meter, setMeter] = useState();

  const meterNoChanged = useCallback(e => {
    setMeterNo(e.target.value);
    setMeter(null);
  }, [setMeterNo, setMeter]);

  const search = useCallback(async id => {
    const loading = weui.loading("查找表计");
    try {
      const res = await commonService.searchMeter(id.padStart(12, "0"));
      setMeter(res.data);
    } catch (err) {
      setMeter(null);
      weui.topTips(getAxiosError(err));
    } finally {
      loading.hide();
    }
  }, [setMeter]);

  const handleCancel = useCallback(e => {
    setMeter(null);
    setMeterNo("");
  }, [setMeterNo, setMeter]);

  const bindMeter = useCallback(async id => {
    const loading = weui.loading("绑定表计");
    try {
      await userService.bindMeter(id);
      await dispatch(clearMeters());
      await dispatch(refreshMeters());
      navigate(urls.meters());
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      loading.hide();
    }
  }, [navigate, dispatch]);

  const handleScan = useCallback(e => {
    scanCode(code => {
      setMeterNo(code);
      search(code);
    }, err => {
      weui.topTips(err);
    });
  }, [scanCode, setMeterNo, search]);

  return (
    <>
      <CellsGroup>
        <CellsTitle>绑定表计</CellsTitle>
        <Cells>
          <Cell vcode htmlFor="elMeterNo">
            <CellHeader>
              <span className="weui-label">表计编号</span>
            </CellHeader>
            <CellBody flex style={ { height: 56 } }>
              <Input id="elMeterNo" className="self-center" type="number" cell placeholder="请输入表计编号" value={ meterNo } onChange={ meterNoChanged } />
              <Button className="scan-btn" style={ { display: scanCodeEnabled ? "" : "none" } } vcode onClick={ handleScan }>
                <i className="iconfont icon-saoyisao text-2xl"></i>扫码
              </Button>
            </CellBody>
          </Cell>
        </Cells>
        <Cells>
          <CellButton type="primary" disabled={ !meterNo } onClick={ e => search(meterNo) }>下一步</CellButton>
        </Cells>

        {
          meter && <Cells>
            <Preview>
              <PreviewHead>
                <PreviewItem label="显示名称">{ meter.name }</PreviewItem>
              </PreviewHead>
              <PreviewBody>
                <PreviewItem label="表计编号">{ meter.meterNo }</PreviewItem>
                <PreviewItem label="表计类别">{ meter.meterClass }</PreviewItem>
                <PreviewItem label="所属区域">{ meter.corpName }</PreviewItem>
                <PreviewItem label="表计地址">{ meter.address }</PreviewItem>
              </PreviewBody>
              <PreviewFoot>
                <PreviewButton onClick={ handleCancel }>取消</PreviewButton>
                <PreviewButton primary onClick={ e => bindMeter(meter.meterNo) }>绑定</PreviewButton>
              </PreviewFoot>
            </Preview>
          </Cells>
        }
      </CellsGroup>
    </>
  );
};

export const MeterBinding = withWechatScanCode(MeterBindingInner);
